import { useContext } from 'react';
import { LanguageContext } from '../../AppContext';
import constantsTexts from './constants.json';
import authTexts from './auth.json';
import dashboardTexts from './dashboard.json';
import addTicketTexts from './addTicket.json';
import taskTexts from './task.json';
import ticketTexts from './ticket.json';
import warningModalTexts from './warningModal.json';
import statusTexts from './status.json';
import ticketTypeTexts from './tickeType.json';

import * as I from './interfaces';

export const getConstantsTranslatedKey = (
  key: keyof I.ConstantsTextKeys
): string[] => {
  const { language } = useContext(LanguageContext);
  return constantsTexts[language][key];
};

export const getAuthTranslatedKey = (
  key: keyof I.AuthTextKeys
): string => {
  const { language } = useContext(LanguageContext);
  return authTexts[language][key];
};

export const getDashboardTranslatedKey = (
  key: keyof I.DashboardTextKeys
): string => {
  const { language } = useContext(LanguageContext);
  return dashboardTexts[language][key];
};

export const getAddTicketTranslatedKey = (
  key: keyof I.AddTicketTextKeys
): string => {
  const { language } = useContext(LanguageContext);
  return addTicketTexts[language][key];
};

export const getTicketTranslatedKey = (
  key: keyof I.TicketTextKeys
): string => {
  const { language } = useContext(LanguageContext);
  return ticketTexts[language][key];
};

export const getTaskTranslatedKey = (
  key: keyof I.TaskTextKeys
): string => {
  const { language } = useContext(LanguageContext);
  return taskTexts[language][key];
};

export const getWarningModalTranslatedKey = (
  key: keyof I.WarningModalTextKeys
): string => {
  const { language } = useContext(LanguageContext);
  return warningModalTexts[language][key];
};

export const getStatusTranslatedKey = (
  key: keyof I.StatusTextKeys
): string => {
  const { language } = useContext(LanguageContext);
  return statusTexts[language][key];
};

export const getTicketTypeTranslatedKey = (
  key: keyof I.TicketTypeTextKeys
): string => {
  const { language } = useContext(LanguageContext);
  return ticketTypeTexts[language][key];
};
